<template>
  <div>
    <!-- <banner :_isMobile="_isMobile"></banner> -->
    <indexMobile v-if="_isMobile" :configurationData="configurationData" :bannerPics="bannnerData.appItems"></indexMobile>
    <indexPc v-else :configurationData="configurationData" :bannerPics="bannnerData.pcItems"></indexPc>
    <!-- <customizedService v-if="!_isMobile" text="我要" colorText="专属定制服务"></customizedService> -->
    <!-- <iconComponents :isMobile="_isMobile"></iconComponents> -->
  </div>
</template>

<script>
  import banner from '@/components/swiper'
  import indexPc from './pc/indexPc.vue'
  import indexMobile from './mobile/indexMobile.vue'
  import customizedService from '@/components/customizedServicePc'
  import iconComponents from '../components/iconComponents.vue'
  import axios from 'axios'
  export default {
    components: {
      customizedService,
      banner,
      indexPc,
      indexMobile,
      iconComponents
    },
    metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false,
        configurationData: null,
        bannnerData:{
          pcItems:[
            {
              imageUrl: 'https://cdn.youjiajk.com/2025bannerpc管家.png',
              jumpType: 2,
              jumpUrl:''
            },
            {
              imageUrl: 'https://cdn.youjiajk.com/2025bannerpc服务数据.png',
              jumpType: 2,
              jumpUrl:''
            },
            {
              imageUrl: 'https://cdn.youjiajk.com/2025bannerpc护士护工.png',
              jumpType: 2,
              jumpUrl:''
            }
          ],
          appItems:[
            {
              imageUrl: 'https://cdn.youjiajk.com/2025bannerapp管家.png',
              jumpType: 2,
              jumpUrl:''
            },
            {
              imageUrl: 'https://cdn.youjiajk.com/2025bannerapp服务数据.png',
              jumpType: 2,
              jumpUrl:''
            },
            {
              imageUrl: 'https://cdn.youjiajk.com/2025bannerapp护士护工.png',
              jumpType: 2,
              jumpUrl:''
            }
          ]
        }
      }
    },
    created() {
      this._isMobile = this.$util._isMobile()
      this.getData()
      // this.getBannerData();
    },
    methods: {
      getData(){
        let url = ''
        let _currentUrl = window.location.href
        // 判断是不是测试环境的域名
        if (_currentUrl.indexOf('youjiajk.com') > -1) {
          url = "https://ums.youjiajk.com/website/dict/find?groupId=2023110309"
        } else {
          url = 'https://ums.youjiajktest.com/website/dict/find?groupId=2023110309'
        }
        axios.get(url, {}).then(res => {
          if(res.data.code == 0) {
            this.configurationData = res.data.data
          }
        })
      },
      getBannerData() {
        let url = ''
        let _currentUrl = window.location.href
        // 判断是不是测试环境的域名
        if (_currentUrl.indexOf('youjiajk.com') > -1) {
          url = "https://appapi.youjiajk.com/ow/v1/queryOfficialWebsiteBannerList"
        } else {
          url = 'https://appapi.youjiajktest.com/ow/v1/queryOfficialWebsiteBannerList'
        }
        axios.get(url, {}).then(res => {
          if(res.data.code == 0) {
            let items = {}
            if (res.data && res.data.data && res.data.data.length > 0) {
              items = JSON.parse(res.data.data[0].items);
            }
            //pc
            if (items && items.pcItems) {
              items.pcItems.forEach(element => {
                if (element.dateStatus === 1) {
                  this.bannnerData.pcItems.push({
                    imageUrl: element.imageUrl[0].url,
                    jumpType: element.jumpType,
                    jumpUrl:element.jumpUrl
                  })
                }
              });
            }
            
            this.bannnerData.pcItems.push({
              imageUrl: 'https://cdn.youjiajk.com/indexBannerPc_new.png',
              jumpType: 2,
              jumpUrl:''
            })

            //移动
            if (items && items.appItems) {
              items.appItems.forEach(element => {
                if (element.dateStatus === 1) {
                  this.bannnerData.appItems.push({
                    imageUrl: element.imageUrl[0].url,
                    jumpType: element.jumpType,
                    jumpUrl:element.jumpUrl
                  })
                }
              });
            }
            
            this.bannnerData.appItems.push({
              imageUrl: 'https://cdn.youjiajk.com/indexBannerMobile.png',
              jumpType: 2,
              jumpUrl:''
            })
          } else {
            this.bannnerData.pcItems.push({
              imageUrl: 'https://cdn.youjiajk.com/indexBannerPc_new.png',
              jumpType: 2,
              jumpUrl:''
            })

            this.bannnerData.appItems.push({
              imageUrl: 'https://cdn.youjiajk.com/indexBannerMobile.png',
              jumpType: 2,
              jumpUrl:''
            })
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">

</style>


// WEBPACK FOOTER //
// src/views/index.vue